module.exports = __webpack_public_path__ + "img/logo_8coin.5ec35109.png";